import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "card p-6 sm:p-8 mb-4"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "title-main" }, "รายละเอียดการจัดส่ง", -1)
const _hoisted_6 = { class: "flex flex-col space-y-6 mt-3" }
const _hoisted_7 = { class: "shadow w-full rounded-md mt-2 p-7 flex flex-col" }
const _hoisted_8 = { class: "relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" }
const _hoisted_9 = { class: "border-2 border-gray-100 rounded-md p-1" }
const _hoisted_10 = { class: "flex space-x-4 items-center" }
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = ["src", "onerror"]
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "w-full flex flex-col text-left gap-1" }
const _hoisted_15 = { class: "flex justify-between" }
const _hoisted_16 = { class: "clamp-1" }
const _hoisted_17 = { class: "flex flex-col text-left gap-2" }
const _hoisted_18 = { class: "text-xs text-gray-500" }
const _hoisted_19 = { class: "text-xs text-gray-500" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"100%"},
  class: "mt-3 mb-3 border-b-2 border-gray-100 flex self-center"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-base mt-1" }, "วันที่จัดส่งถึงโดยประมาณ", -1)
const _hoisted_22 = { class: "grid grid-cols-5 gap-5" }
const _hoisted_23 = { class: "col-span-full xl:col-span-3" }
const _hoisted_24 = { class: "flex gap-5 mt-2" }
const _hoisted_25 = { class: "text-base" }
const _hoisted_26 = { class: "flex gap-5 mt-2 items-center" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-base" }, "Tracking Number", -1)
const _hoisted_28 = { class: "text-base" }
const _hoisted_29 = { class: "flex gap-5 mt-2" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-base" }, "หมายเหตุ", -1)
const _hoisted_31 = { class: "text-base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.data)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (
        _ctx.data.statusOrderOnSeller !== _ctx.StatusOrderSeller.S0_None &&
        _ctx.data.statusOrderOnSeller !== _ctx.StatusOrderSeller.S1_AwaitingConfirm &&
        _ctx.data.statusOrderOnSeller !== _ctx.StatusOrderSeller.S2_AwaitingPayment &&
        _ctx.data.statusOrderOnSeller !== _ctx.StatusOrderSeller.S3_ToConfirm &&
        !_ctx.data.hasNoShipment
      )
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("img", {
                  class: "bullet_main",
                  src: require('@/assets/icon_bullet/channenshipping-ico.svg'),
                  alt: ""
                }, null, 8, _hoisted_4),
                _hoisted_5
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          (_ctx.data.shippingConfirmedData?.shippingIconUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                class: "min-w-14 max-w-14 min-h-14 max-h-14 rounded-md bg-contain object-contain bg-center bg-no-repeat bg-white border border-gray-100",
                                src: 
                      _ctx.prefixUrlImage +
                      _ctx.data.shippingConfirmedData?.shippingIconUrl
                    ,
                                onerror: `this.src='${_ctx.envMedia}/public/icons/web/empty.png'`
                              }, null, 8, _hoisted_12))
                            : _createCommentVNode("", true),
                          (_ctx.data.shippingConfirmedData?.isCOD)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 1,
                                style: {"width":"24px","height":"12px","padding-right":"0.05rem"},
                                class: "absolute top-1 right-0",
                                src: require('@/assets/images/icon-cod2.png')
                              }, null, 8, _hoisted_13))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.data.shippingConfirmedData?.shippingAliasName), 1)
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.func_service.setData(_ctx.data.shippingConfirmedData)), 1),
                            _createElementVNode("p", _hoisted_19, " ระยะเวลาจัดส่ง " + _toDisplayString(_ctx.data.shippingConfirmedData?.deliveryTime.earliest) + " - " + _toDisplayString(_ctx.data.shippingConfirmedData?.deliveryTime.last), 1)
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _hoisted_20,
                  _createElementVNode("div", null, [
                    _hoisted_21,
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.data.shippingTrackingData?.deliveryOn.day[0]
                        ? _ctx.formathDate(
                            _ctx.data.shippingTrackingData?.deliveryOn.day[0]
                          )
                        : "") + " - " + _toDisplayString(_ctx.data.shippingTrackingData?.deliveryOn.day[1]
                        ? _ctx.formathDate(
                            _ctx.data.shippingTrackingData?.deliveryOn.day[1]
                          )
                        : ""), 1)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.data.shippingTrackingData?.trackingNo || "-"), 1)
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _hoisted_30,
                          _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.data.shippingTrackingData?.note || "-"), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}